export default "__VITE_ASSET__b64752a8__"